"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryGetStoredValue = void 0;
var mobx_1 = require("mobx");
var ProjectStore_1 = __importDefault(require("Project/Stores/ProjectStore"));
var DeletedProjectStore_1 = __importDefault(require("Project/Stores/DeletedProjectStore"));
var DashboardTypes_1 = require("../DashboardTypes");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var Types_2 = require("User/Types");
var StringManipulater_1 = require("Utils/StringManipulater");
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DashboardUtils_1 = require("Dashboard/DashboardUtils");
var ResourceTypes_1 = require("@CommonFrontendBackend/Resources/ResourceTypes");
var DashboardTypes_2 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var SelectionStore_1 = __importDefault(require("Dashboard/Stores/SelectionStore"));
var PageStateChangeConfirmationModal_1 = require("Common/Modal/PageModals/PageStateChangeConfirmationModal");
var LocalStorageKey;
(function (LocalStorageKey) {
    LocalStorageKey["SortBy"] = "dashboardSortBy";
    LocalStorageKey["SortDirection"] = "dashboardSortDirection";
})(LocalStorageKey || (LocalStorageKey = {}));
var tryGetStoredValue = function (key, defaultValue, excluding) {
    var localStorageValue = localStorage.getItem(key);
    if (localStorageValue) {
        var parsedLocalStorageValue = "".concat(localStorageValue).replace(/"/g, "");
        if (parsedLocalStorageValue !== excluding) {
            return parsedLocalStorageValue;
        }
    }
    return defaultValue;
};
exports.tryGetStoredValue = tryGetStoredValue;
var ProjectListStore = (function () {
    function ProjectListStore(projectListFetcher, projectService, projectApiService, projectTelemetry, user, _userList, _rootDataStore, _notifyUser, folderSelectionViewStore, pageResourceApiService, genericHost, page, modal, useHistoryDataStore, usingFeature) {
        if (page === void 0) { page = "pages"; }
        var _this = this;
        this.projectListFetcher = projectListFetcher;
        this.projectService = projectService;
        this.projectApiService = projectApiService;
        this.projectTelemetry = projectTelemetry;
        this.user = user;
        this._userList = _userList;
        this._rootDataStore = _rootDataStore;
        this._notifyUser = _notifyUser;
        this.folderSelectionViewStore = folderSelectionViewStore;
        this.pageResourceApiService = pageResourceApiService;
        this.genericHost = genericHost;
        this.page = page;
        this.modal = modal;
        this.useHistoryDataStore = useHistoryDataStore;
        this.usingFeature = usingFeature;
        this.fetchCounter = 0;
        this._projectCount = 0;
        this._selectedUserIds = [];
        this._selectedStatuses = [];
        this._selectedTags = [];
        this._selectedTemplates = [];
        this.forceFetchProjects = function () {
            return _this.fetchProjects({
                selectedFolder: _this.selectedFolder,
                pageSize: _this._pageSize,
                pageNum: _this._pageNum,
                filter: _this.filter,
                sortBy: _this._sortBy,
                sortDirection: _this._sortDirection,
                blueprintParentId: _this.blueprintParentId,
            });
        };
        this.setBlueprintParent = function (blueprintParent) {
            _this._blueprintParent = blueprintParent;
            _this.resetPageNumber();
            _this.clearSelectedFilters();
        };
        this.clearBlueprintParent = function () {
            _this._blueprintParent = undefined;
            _this.clearSelectedFilters();
        };
        this.updatePageSize = function (isMobile) {
            if (isMobile) {
                _this._pageSize = 10;
            }
            else {
                _this._pageSize = 25;
            }
        };
        this.goNextPage = function () {
            if (!_this.hasNextPage) {
                throw new Error("Page out of bounds");
            }
            ++_this._pageNum;
        };
        this.goPreviousPage = function () {
            if (!_this.hasPreviousPage) {
                throw new Error("Page out of bounds");
            }
            --_this._pageNum;
        };
        this.setSortBy = function (sortBy) {
            if (sortBy !== DashboardTypes_1.SortBy.Relevance) {
                localStorage.setItem(LocalStorageKey.SortBy, sortBy);
            }
            _this._sortBy = sortBy;
        };
        this.setSortDirection = function (sortDirection) {
            localStorage.setItem(LocalStorageKey.SortDirection, sortDirection);
            _this._sortDirection = sortDirection;
        };
        this.setSelectedUserIds = function (selectedUserIds) {
            _this._selectedUserIds = selectedUserIds;
            _this.resetPageNumber();
        };
        this.clearSelectedFilters = function () {
            _this._selectedUserIds = [];
            _this._selectedStatuses = [];
            _this._selectedTags = [];
            _this._selectedTemplates = [];
            _this._selectedEngagementLevels = [];
            _this._selectedPagesWithFilters = [];
        };
        this.setSelectedStatuses = function (selectedStatuses) {
            _this._selectedStatuses = selectedStatuses;
            _this.resetPageNumber();
        };
        this.setSelectedTags = function (selectedTags) {
            _this._selectedTags = selectedTags;
            _this.resetPageNumber();
        };
        this.setSelectedTemplates = function (selectedTemplates) {
            _this._selectedTemplates = selectedTemplates;
            _this.resetPageNumber();
        };
        this.setSearchTerm = function (searchTerm) {
            _this._searchTerm = searchTerm;
            _this._sortBy = DashboardTypes_1.SortBy.Relevance;
            _this._sortDirection = DashboardTypes_1.SortDirection.Descending;
            _this.folderSelectionViewStore.setSelectedFolder(null);
            _this.clearBlueprintParent();
        };
        this.clearSearchTerm = function () {
            _this._searchTerm = undefined;
            _this._sortBy = (0, exports.tryGetStoredValue)(LocalStorageKey.SortBy, DashboardTypes_1.SortBy.LastEditedAt, DashboardTypes_1.SortBy.Relevance);
            _this._sortDirection = (0, exports.tryGetStoredValue)(LocalStorageKey.SortDirection, DashboardTypes_1.SortDirection.Descending);
        };
        this.restoreProjects = function (indexes) { return __awaiter(_this, void 0, void 0, function () {
            var deletedProjects, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectedFolder !== DashboardTypes_2.ProjectCollection.Deleted) {
                            throw new Error("Can only restore deleted pages");
                        }
                        deletedProjects = this.getProjectStoresByIndexes(indexes);
                        return [4, this.projectService.restore(deletedProjects)];
                    case 1:
                        response = _a.sent();
                        if (!response.success) return [3, 3];
                        this.notifyUserSuccess(response.message);
                        return [4, this.forceFetchProjects()];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        this.notifyUserWarn(response.message);
                        _a.label = 4;
                    case 4: return [2];
                }
            });
        }); };
        this.starProjects = function (indexes) { return __awaiter(_this, void 0, void 0, function () {
            var projectStores, unstarredProject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectedFolder === DashboardTypes_2.ProjectCollection.Deleted) {
                            throw new Error("Can't star deleted pages");
                        }
                        projectStores = this.getProjectStoresByIndexes(indexes);
                        unstarredProject = projectStores.find(function (projectStore) { return !projectStore.isStarred; });
                        if (!!unstarredProject) return [3, 2];
                        return [4, Promise.all(projectStores.map(function (projectStore) { return projectStore.unstar(); }))];
                    case 1:
                        _a.sent();
                        return [3, 4];
                    case 2: return [4, Promise.all(projectStores.map(function (projectStore) { return projectStore.star(); }))];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2];
                }
            });
        }); };
        this.getProjectStoresByIndexes = function (indexes) {
            return (0, mobx_1.computed)(function () {
                return indexes
                    .map(function (index) {
                    if (index < _this._projectStores.length) {
                        return _this._projectStores[index];
                    }
                })
                    .filter(function (projectStore) { return !!projectStore; });
            }).get();
        };
        this.setProjectCount = function (projectCount) {
            _this._projectCount = projectCount;
        };
        this.fetchProjects = function (_a) { return __awaiter(_this, [_a], Promise, function (_b) {
            var myFetchCounter, projectsFetched, projectCount, _c, projects, count;
            var _this = this;
            var selectedFolder = _b.selectedFolder, pageSize = _b.pageSize, pageNum = _b.pageNum, filter = _b.filter, sortBy = _b.sortBy, sortDirection = _b.sortDirection, blueprintParentId = _b.blueprintParentId;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(0, DashboardUtils_1.isASystemFolder)(selectedFolder)) {
                            filter["folderId"] = selectedFolder;
                        }
                        this._isLoadingProjects = true;
                        ++this.fetchCounter;
                        myFetchCounter = this.fetchCounter;
                        projectsFetched = null;
                        if (!(blueprintParentId || !!filter.searchTerm || (0, DashboardUtils_1.isASystemFolder)(selectedFolder))) return [3, 2];
                        return [4, this.projectListFetcher.fetch(pageSize, pageNum, filter, sortBy, sortDirection, selectedFolder, blueprintParentId)];
                    case 1:
                        _c = _d.sent(), projects = _c.projects, count = _c.count;
                        projectsFetched = projects;
                        projectCount = count;
                        if (myFetchCounter === this.fetchCounter) {
                            this.setProjectList(projectsFetched, selectedFolder);
                            this.setProjectCount(projectCount);
                            (0, mobx_1.runInAction)(function () {
                                _this._isLoadingProjects = false;
                            });
                        }
                        return [3, 3];
                    case 2:
                        this.fetchResources();
                        _d.label = 3;
                    case 3: return [2];
                }
            });
        }); };
        this.fetchResources = function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], __read(args_1), false), void 0, function (isLoadingNext) {
                var myFetchCounter, filter, response, pages, projectsFetched, projectList, cursor;
                var _this = this;
                if (isLoadingNext === void 0) { isLoadingNext = false; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this._isLoadingProjects = true;
                            ++this.fetchCounter;
                            myFetchCounter = this.fetchCounter;
                            filter = this.filter;
                            filter.folderId = this.selectedFolder;
                            return [4, this.pageResourceApiService.getFolderContents(this.selectedFolder, this.pageSize, isLoadingNext ? this.skipPages : 0, filter, this._sortBy, this._sortDirection)];
                        case 1:
                            response = _a.sent();
                            pages = response.resources.filter(function (r) { return r.type === ResourceTypes_1.DashboardResourceType.Page; });
                            projectsFetched = pages;
                            if (myFetchCounter === this.fetchCounter) {
                                projectList = isLoadingNext ? __spreadArray(__spreadArray([], __read(this._projects), false), __read(projectsFetched), false) : projectsFetched;
                                this.setProjectList(projectList, this.selectedFolder);
                                (0, mobx_1.runInAction)(function () {
                                    _this._isLoadingProjects = false;
                                });
                                if (response.nextPage) {
                                    cursor = new URLSearchParams(response.nextPage);
                                    this.setSkipPages(Number(cursor.get("pageSkip")));
                                }
                                else {
                                    this.setSkipPages(0);
                                }
                            }
                            return [2];
                    }
                });
            });
        };
        this._isLoadingProjects = true;
        this._pageSize = 25;
        this._pageNum = 0;
        this.clearSelectedFilters();
        this._sortBy = (0, exports.tryGetStoredValue)(LocalStorageKey.SortBy, DashboardTypes_1.SortBy.LastEditedAt, DashboardTypes_1.SortBy.Relevance);
        this._sortDirection = (0, exports.tryGetStoredValue)(LocalStorageKey.SortDirection, DashboardTypes_1.SortDirection.Descending);
        this._projects = [];
        this._projectStores = [];
        this.selectionStore = new SelectionStore_1.default();
        var debouncedFetchProjects = (0, lodash_1.debounce)(function (projectFilters) {
            _this.fetchProjects(projectFilters);
        }, 200, {
            leading: true,
            trailing: true,
        });
        this.disposeClearFilterReaction = (0, mobx_1.reaction)(function () {
            return _this.selectedFolder;
        }, function () {
            if ((0, DashboardUtils_1.isASystemFolder)(_this.folderSelectionViewStore.selectedFolder)) {
                _this.clearSelectedFilters();
            }
        }, { fireImmediately: true });
        this.disposeFetchReaction = (0, mobx_1.reaction)(function () { return ({
            selectedFolder: _this.selectedFolder,
            pageSize: _this._pageSize,
            pageNum: _this._pageNum,
            filter: _this.filter,
            sortBy: _this._sortBy,
            sortDirection: _this._sortDirection,
            blueprintParentId: _this.blueprintParentId,
        }); }, (0, mobx_1.action)(function (projectFilters) {
            if (_this.page === "pages") {
                _this._isLoadingProjects = true;
                return debouncedFetchProjects(projectFilters);
            }
            _this._isLoadingProjects = false;
            return;
        }), {
            fireImmediately: true,
        });
    }
    Object.defineProperty(ProjectListStore.prototype, "projectStores", {
        get: function () {
            return this._projectStores;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "selectedFolder", {
        get: function () {
            return this.folderSelectionViewStore.selectedFolder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        enumerable: false,
        configurable: true
    });
    ProjectListStore.prototype.resetPageNumber = function () {
        this._pageNum = 0;
    };
    Object.defineProperty(ProjectListStore.prototype, "pageNum", {
        get: function () {
            return this._pageNum;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "sortDirection", {
        get: function () {
            return this._sortDirection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "isLoadingProjects", {
        get: function () {
            return this._isLoadingProjects;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "isSinglePage", {
        get: function () {
            return this._projectCount <= this.pageSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "projectCount", {
        get: function () {
            return this._projectCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "displayedProjectCount", {
        get: function () {
            return this._projectStores.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "pageCount", {
        get: function () {
            return Math.max(1, Math.ceil(this._projectCount / this.pageSize));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "hasNextPage", {
        get: function () {
            return this.pageNum < this.pageCount - 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "hasNextResourcePage", {
        get: function () {
            return this.skipPages > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "hasPreviousPage", {
        get: function () {
            return this.pageNum > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "userList", {
        get: function () {
            return this._userList;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "searchTerm", {
        get: function () {
            return this._searchTerm;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "filter", {
        get: function () {
            return {
                user: this.selectedUserIds,
                status: this.selectedStatuses,
                searchTerm: this.searchTerm,
                tags: this.selectedTags,
                templates: this.selectedTemplates,
                engagementLevel: this._selectedEngagementLevels,
                pagesWith: this._selectedPagesWithFilters,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "isFiltered", {
        get: function () {
            return this.areAnyFiltersSelected || !!this.searchTerm;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "selectedUserIds", {
        get: function () {
            return this._selectedUserIds;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "selectedStatuses", {
        get: function () {
            return this._selectedStatuses;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "selectedTags", {
        get: function () {
            return this._selectedTags;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "allTags", {
        get: function () {
            return this._rootDataStore.projectTagDataStore.projectTags;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "selectedTemplates", {
        get: function () {
            return this._selectedTemplates;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "blueprintParentId", {
        get: function () {
            return this._blueprintParent && this._blueprintParent._id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "blueprintParentName", {
        get: function () {
            return this._blueprintParent && this._blueprintParent.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "selectedEngagementLevels", {
        get: function () {
            return this._selectedEngagementLevels;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "selectedPagesWithFilters", {
        get: function () {
            return this._selectedPagesWithFilters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ProjectListStore.prototype, "areAnyFiltersSelected", {
        get: function () {
            return (!!this.selectedUserIds.length ||
                !!this.selectedStatuses.length ||
                !!this.selectedTags.length ||
                !!this.selectedTemplates.length ||
                !!this.selectedEngagementLevels.length ||
                !!this.selectedPagesWithFilters.length);
        },
        enumerable: false,
        configurable: true
    });
    ProjectListStore.prototype.disposeReactions = function () {
        this.disposeClearFilterReaction();
        this.disposeFetchReaction();
    };
    ProjectListStore.prototype.setSelectedEngagementLevels = function (engagementLevels) {
        this._selectedEngagementLevels = engagementLevels;
        this.resetPageNumber();
    };
    ProjectListStore.prototype.setPagesWithFilters = function (pagesWithFilters) {
        this._selectedPagesWithFilters = pagesWithFilters;
        this.resetPageNumber();
    };
    ProjectListStore.prototype.restoreAndArchiveProjects = function (indexes) {
        return __awaiter(this, void 0, Promise, function () {
            var deletedProjectIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deletedProjectIds = this.getProjectStoresByIndexes(indexes).map(function (deletedProjectStore) { return deletedProjectStore._id; });
                        return [4, this.projectApiService.restoreProjectsAndArchive(deletedProjectIds)];
                    case 1:
                        _a.sent();
                        this.notifyUserSuccess("".concat((0, StringManipulater_1.pluralise)(deletedProjectIds.length, "page"), " restored"));
                        this.forceFetchProjects();
                        return [2];
                }
            });
        });
    };
    ProjectListStore.prototype.restoreAndSetProjectsActive = function (indexes) {
        return __awaiter(this, void 0, Promise, function () {
            var deletedProjectIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deletedProjectIds = this.getProjectStoresByIndexes(indexes).map(function (deletedProjectStore) { return deletedProjectStore._id; });
                        return [4, this.projectApiService.restoreProjectsAndSetActive(deletedProjectIds)];
                    case 1:
                        _a.sent();
                        this.notifyUserSuccess("".concat((0, StringManipulater_1.pluralise)(deletedProjectIds.length, "page"), " restored"));
                        this.forceFetchProjects();
                        return [2];
                }
            });
        });
    };
    ProjectListStore.prototype.getSelectionStore = function () {
        return this.selectionStore;
    };
    ProjectListStore.prototype.moveResourcesToFolder = function (indexes, fromFolder, targetFolder) {
        return __awaiter(this, void 0, Promise, function () {
            var isMoveValid, resources, _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4, this.isMoveValid(indexes, targetFolder)];
                    case 1:
                        isMoveValid = _b.sent();
                        if (!isMoveValid) return [3, 12];
                        resources = this.mapStoresToResources(indexes);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 10, , 11]);
                        _a = fromFolder;
                        switch (_a) {
                            case DashboardTypes_2.ProjectCollection.Archived: return [3, 3];
                            case DashboardTypes_2.ProjectCollection.Deleted: return [3, 5];
                        }
                        return [3, 7];
                    case 3: return [4, this.pageResourceApiService.unarchiveResources(targetFolder, resources)];
                    case 4:
                        _b.sent();
                        return [3, 9];
                    case 5: return [4, this.pageResourceApiService.restoreResources(targetFolder, resources)];
                    case 6:
                        _b.sent();
                        return [3, 9];
                    case 7: return [4, this.pageResourceApiService.moveResources(targetFolder, resources)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9: return [3, 11];
                    case 10:
                        e_1 = _b.sent();
                        this.notifyUserWarn("Could not move resources from ".concat(fromFolder, " to ").concat(targetFolder));
                        throw e_1;
                    case 11:
                        this.forceFetchProjects();
                        _b.label = 12;
                    case 12: return [2];
                }
            });
        });
    };
    ProjectListStore.prototype.deleteProjects = function (indexes) {
        return __awaiter(this, void 0, Promise, function () {
            var projectStores, shouldDelete, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectedFolder === DashboardTypes_2.ProjectCollection.Deleted) {
                            throw new Error("Can't delete deleted pages");
                        }
                        projectStores = this.getProjectStoresByIndexes(indexes);
                        if (projectStores.length === 0) {
                            return [2];
                        }
                        return [4, this.projectService.confirmDelete(projectStores)];
                    case 1:
                        shouldDelete = _a.sent();
                        if (!shouldDelete) {
                            return [2];
                        }
                        return [4, this.projectService.delete(projectStores)];
                    case 2:
                        response = _a.sent();
                        if (!response.success) return [3, 4];
                        this.notifyUserSuccess(response.message);
                        return [4, this.forceFetchProjects()];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        this.notifyUserWarn(response.message);
                        _a.label = 5;
                    case 5: return [2];
                }
            });
        });
    };
    ProjectListStore.prototype.archiveProjects = function (indexes) {
        return __awaiter(this, void 0, Promise, function () {
            var projectStores, unarchivedProject, projectString, archiveString, isArchivingBlueprints, okToArchive, _a, pageResources, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.selectedFolder === DashboardTypes_2.ProjectCollection.Deleted) {
                            throw new Error("Can't archive deleted pages");
                        }
                        projectStores = this.getProjectStoresByIndexes(indexes);
                        unarchivedProject = projectStores.find(function (projectStore) { return !projectStore.isArchived; });
                        projectString = (0, StringManipulater_1.pluralise)(projectStores.length, "Page");
                        archiveString = unarchivedProject ? "archive" : "unarchive";
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 8, , 9]);
                        if (!!unarchivedProject) return [3, 3];
                        return [4, Promise.all(projectStores.map(function (projectStore) { return projectStore.unarchive(); }))];
                    case 2:
                        _b.sent();
                        this.notifyUserSuccess("".concat(projectString, " Unarchived"));
                        this.forceFetchProjects();
                        return [3, 7];
                    case 3:
                        isArchivingBlueprints = projectStores.every(function (p) { return p.isBlueprint; });
                        _a = isArchivingBlueprints;
                        if (_a) return [3, 5];
                        return [4, (0, PageStateChangeConfirmationModal_1.confirmArchiveWithModal)(this.modal, this.useHistoryDataStore)];
                    case 4:
                        _a = (_b.sent());
                        _b.label = 5;
                    case 5:
                        okToArchive = _a;
                        if (!okToArchive) return [3, 7];
                        pageResources = projectStores.map(function (projectStore) { return ({
                            type: ResourceTypes_1.DashboardResourceType.Page,
                            id: projectStore._id,
                        }); });
                        return [4, this.pageResourceApiService.archiveResources(pageResources)];
                    case 6:
                        _b.sent();
                        this.notifyUserSuccess("".concat(projectString, " Archived"));
                        this.forceFetchProjects();
                        _b.label = 7;
                    case 7: return [3, 9];
                    case 8:
                        e_2 = _b.sent();
                        this.notifyUserWarn("Could not ".concat(archiveString, " ").concat(projectString));
                        return [3, 9];
                    case 9: return [2];
                }
            });
        });
    };
    ProjectListStore.prototype.setProjectList = function (projects, collection) {
        var _this = this;
        this._projects = projects;
        if (collection === DashboardTypes_2.ProjectCollection.Deleted) {
            this._projectStores = this._projects.map(function (project) {
                return new DeletedProjectStore_1.default(project, _this.projectApiService);
            });
        }
        else {
            this._projectStores = this._projects.map(function (project) {
                return new ProjectStore_1.default(project, _this.projectApiService, _this.pageResourceApiService, _this.user, _this.projectTelemetry, _this._rootDataStore, _this.genericHost);
            });
        }
        this.selectionStore.setNumberOfVisibleProjects(this._projectStores.length);
    };
    ProjectListStore.prototype.mapStoresToResources = function (indexes) {
        var projectStores = this.getProjectStoresByIndexes(indexes);
        var resources = projectStores.map(function (ps) {
            return {
                id: ps._id,
                type: ResourceTypes_1.DashboardResourceType.Page,
            };
        });
        return resources;
    };
    ProjectListStore.prototype.isMoveValid = function (projectIndexes, targetFolder) {
        return __awaiter(this, void 0, Promise, function () {
            var projectStores, projectStores_1, projectStores_1_1, projectStore, e_3_1;
            var e_3, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!(0, DashboardUtils_1.isASystemFolder)(targetFolder)) return [3, 8];
                        projectStores = this.getProjectStoresByIndexes(projectIndexes);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, 7, 8]);
                        projectStores_1 = __values(projectStores), projectStores_1_1 = projectStores_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!projectStores_1_1.done) return [3, 5];
                        projectStore = projectStores_1_1.value;
                        if (!projectStore.templateParent) return [3, 4];
                        return [4, this.notifyUserWarn("Cannot move Blueprint children into a custom folder")];
                    case 3:
                        _b.sent();
                        return [2, false];
                    case 4:
                        projectStores_1_1 = projectStores_1.next();
                        return [3, 2];
                    case 5: return [3, 8];
                    case 6:
                        e_3_1 = _b.sent();
                        e_3 = { error: e_3_1 };
                        return [3, 8];
                    case 7:
                        try {
                            if (projectStores_1_1 && !projectStores_1_1.done && (_a = projectStores_1.return)) _a.call(projectStores_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7];
                    case 8: return [2, true];
                }
            });
        });
    };
    ProjectListStore.prototype.setSkipPages = function (skipPages) {
        this.skipPages = skipPages;
    };
    ProjectListStore.prototype.notifyUserWarn = function (msg) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._notifyUser.warn(msg)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    ProjectListStore.prototype.notifyUserSuccess = function (msg) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this._notifyUser.success(msg)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "projectStores", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_b = typeof kaleidoscope_1.FolderSelectionState !== "undefined" && kaleidoscope_1.FolderSelectionState) === "function" ? _b : Object),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "selectedFolder", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "pageSize", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProjectListStore.prototype, "resetPageNumber", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "pageNum", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof DashboardTypes_1.SortBy !== "undefined" && DashboardTypes_1.SortBy) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "sortBy", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_d = typeof DashboardTypes_1.SortDirection !== "undefined" && DashboardTypes_1.SortDirection) === "function" ? _d : Object),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "sortDirection", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "isLoadingProjects", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "isSinglePage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "projectCount", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "displayedProjectCount", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "pageCount", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "hasNextPage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "hasNextResourcePage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "hasPreviousPage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_e = typeof Types_2.IAccountUserList !== "undefined" && Types_2.IAccountUserList) === "function" ? _e : Object),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "userList", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "searchTerm", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_f = typeof Types_1.PagesListFilter !== "undefined" && Types_1.PagesListFilter) === "function" ? _f : Object),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "filter", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "isFiltered", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "selectedUserIds", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_g = typeof Array !== "undefined" && Array) === "function" ? _g : Object),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "selectedStatuses", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "selectedTags", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "allTags", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "blueprintParentId", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "blueprintParentName", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ProjectListStore.prototype, "areAnyFiltersSelected", null);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_h = typeof Array !== "undefined" && Array) === "function" ? _h : Object)
    ], ProjectListStore.prototype, "_projectStores", void 0);
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Array)
    ], ProjectListStore.prototype, "_projects", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ProjectListStore.prototype, "_pageSize", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ProjectListStore.prototype, "_pageNum", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_j = typeof DashboardTypes_1.SortBy !== "undefined" && DashboardTypes_1.SortBy) === "function" ? _j : Object)
    ], ProjectListStore.prototype, "_sortBy", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_k = typeof DashboardTypes_1.SortDirection !== "undefined" && DashboardTypes_1.SortDirection) === "function" ? _k : Object)
    ], ProjectListStore.prototype, "_sortDirection", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], ProjectListStore.prototype, "_isLoadingProjects", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ProjectListStore.prototype, "_projectCount", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], ProjectListStore.prototype, "_selectedUserIds", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_l = typeof Array !== "undefined" && Array) === "function" ? _l : Object)
    ], ProjectListStore.prototype, "_selectedStatuses", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], ProjectListStore.prototype, "_searchTerm", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], ProjectListStore.prototype, "_selectedTags", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], ProjectListStore.prototype, "_selectedTemplates", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "_blueprintParent", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], ProjectListStore.prototype, "_selectedEngagementLevels", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], ProjectListStore.prototype, "_selectedPagesWithFilters", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ProjectListStore.prototype, "skipPages", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "forceFetchProjects", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "setBlueprintParent", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "clearBlueprintParent", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "updatePageSize", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "goNextPage", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "goPreviousPage", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "setSortBy", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "setSortDirection", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "setSelectedUserIds", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "clearSelectedFilters", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "setSelectedStatuses", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "setSelectedTags", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "setSelectedTemplates", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectListStore.prototype, "setSelectedEngagementLevels", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], ProjectListStore.prototype, "setPagesWithFilters", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "setSearchTerm", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "clearSearchTerm", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "restoreProjects", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", typeof (_m = typeof Promise !== "undefined" && Promise) === "function" ? _m : Object)
    ], ProjectListStore.prototype, "restoreAndArchiveProjects", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", typeof (_o = typeof Promise !== "undefined" && Promise) === "function" ? _o : Object)
    ], ProjectListStore.prototype, "restoreAndSetProjectsActive", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", typeof (_p = typeof Promise !== "undefined" && Promise) === "function" ? _p : Object)
    ], ProjectListStore.prototype, "deleteProjects", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "starProjects", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", typeof (_q = typeof Promise !== "undefined" && Promise) === "function" ? _q : Object)
    ], ProjectListStore.prototype, "archiveProjects", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "setProjectCount", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array, typeof (_r = typeof kaleidoscope_1.FolderSelectionState !== "undefined" && kaleidoscope_1.FolderSelectionState) === "function" ? _r : Object]),
        __metadata("design:returntype", void 0)
    ], ProjectListStore.prototype, "setProjectList", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "fetchProjects", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ProjectListStore.prototype, "fetchResources", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], ProjectListStore.prototype, "setSkipPages", null);
    return ProjectListStore;
}());
exports.default = ProjectListStore;
